// extracted by mini-css-extract-plugin
module.exports = {"BottomRow":"style_BottomRow__-9FDk"};